import React, { useState, useEffect } from 'react';
import UserCard from './UserCard';
import useAppStore from '../store/useAppStore';
import './UserSelectionPage.css';

/**
 * 用户选择页面
 * 展示 5 个用户卡片供选择
 */
const UserSelectionPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const selectUser = useAppStore((state) => state.selectUser);

  useEffect(() => {
    // 加载用户数据
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      // 使用 Vite 的 BASE_URL 确保路径正确
      const baseUrl = import.meta.env.BASE_URL || '/demo/';
      const response = await fetch(`${baseUrl}users_meta.json`);
      
      if (!response.ok) {
        throw new Error('Failed to load user data');
      }
      
      const data = await response.json();
      
      // 只取前 5 个用户
      setUsers(data.slice(0, 5));
    } catch (err) {
      console.error('Error fetching users:', err);
      setError(err.message || 'Failed to load user data');
    } finally {
      setLoading(false);
    }
  };

  const handleUserSelect = (user) => {
    // 更新全局状态
    selectUser(user.id, user);
  };

  if (loading) {
    return (
      <div className="selection-page">
        <div className="loading-state">
          <div className="loading-spinner-small"></div>
          <p>Loading user data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="selection-page">
        <div className="error-state">
          <p className="error-message">❌ {error}</p>
          <button className="retry-button" onClick={fetchUsers}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="selection-page">
      <div className="selection-container">
        <header className="page-header">
          <h1 className="page-title">
            <span className="title-gradient">MemRec</span>
            <span className="title-subtitle">Collaborative Memory-Augmented Agentic System Demo</span>
          </h1>
          <p className="page-description">
            Select a user persona to experience the collaborative memory-based personalized recommendation process
          </p>
        </header>

        <div className="users-grid">
          {users.map((user) => (
            <UserCard
              key={user.id}
              user={user}
              onClick={handleUserSelect}
            />
          ))}
        </div>

        <footer className="page-footer">
          <p>💡 Click any card to start the recommendation process</p>
        </footer>
      </div>
    </div>
  );
};

export default UserSelectionPage;

